import { FC, useEffect, useState } from 'react';
import PCCom from '../../components/PCCom';
import H5Com from '../../components/H5Com';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import getLocal from '@/app/utils/getLocal';

const TheComp: FC = () => {
    const { t } = useLang('dp3.teaser.KSP4APP');
    const [isPC, setIsPC] = useState(true);
    const { locale } = getLocal();

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsPC(window.innerWidth > 1024);
        }
    }, []);

    return (
        <div id="dp3-teaser-F" className={`dp3-module-box KSP4APP dp3-teaser-F ${css.theComp}`}>
            {isPC ? (
                <PCCom
                    title={t('title')}
                    img={
                        locale === 'jp'
                            ? 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717762796132/cc1%20(1).jpg'
                            : '/responsive/picture/dp3/teaser/6.png'
                    }
                    subtitle={t('lMsg')}
                    desc={t('rMsg')}
                />
            ) : (
                <H5Com
                    title={t('title')}
                    imgArr={
                        locale === 'jp'
                            ? ['https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717762882193/cc2%20(1).jpg']
                            : [
                                  '/responsive/picture/dp3/teaser/6_1_M.jpg',
                                  '/responsive/picture/dp3/teaser/6_2_M.jpg',
                                  '/responsive/picture/dp3/teaser/6_3_M.jpg',
                              ]
                    }
                    subtitle={t('lMsg')}
                    desc={t('rMsg')}
                    cls="dp3-teaser-F"
                />
            )}
        </div>
    );
};

export default TheComp;
